import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import VueGallerySlideshow from 'vue-gallery-slideshow';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhone, faEnvelopeSquare, faEnvelopeOpen, faComment} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './assets/css/main.css';

library.add([faPhone, faEnvelopeSquare, faEnvelopeOpen, faComment])

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-gallery-slideshow', VueGallerySlideshow)

import routes from './routes';

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(BootstrapVue)

const router = new VueRouter({mode: 'history', routes});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
